export function request(state) {
    return state.set('state', 'IN_PROGRESS');
}

export function finish(state, { data }) {
    return state.mergeIn([ 'items', '' + data.id ], data)
        .set('state', 'FINISHED');
}

export function error(state, { errors }) {
    return state.set('state', 'ERROR');
}
